export default "__VITE_ASSET__DijtV4qm__"